import React, { Component } from 'react'
//import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'
import LogoEmpresa from '../../components/logoEmpresa'
import Carousel from '../../components/carousel'
import About from '../../components/about'
import SaleProducts from '../../components/productosOferta'

export default class Home extends Component {
  render() {
    window.scrollTo(0, 0)
    return (
      <React.Fragment>
        <LogoEmpresa />
        <Carousel />
        <Container>
          <Row>
            <Col>
            <SaleProducts />
            </Col>
          </Row>
          <Row>
          <Col>
            <About />
          </Col>
          </Row>
        </Container>
      </React.Fragment>

    )
  }
}